







import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "ClearFilters",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
});
